module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintAadharAgreementLetter"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printAdharAgreementLetter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printAdharAgreementLetter"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table printing"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                        "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                        ")]), _c('br'), _c('br'), _vm._m(1)])])])]), _vm._v(" "), _c('div', [_c('p', {
    staticClass: "text-justify"
  }, [(_vm.seeRecord.member_id) ? _c('big', {
    staticClass: "text-justify"
  }, [_vm._v(" \n                            मैं श्री "), _c('strong', [_vm._v(_vm._s(_vm.seeRecord.member.name))]), _vm._v(" c/o  "), (_vm.mem.gender == 'Male') ? _c('strong', [_vm._v(_vm._s(_vm.mem.fatherName))]) : _c('strong', [_vm._v(_vm._s(_vm.mem.spouseName))]), _vm._v(" निवासी "), _c('b', [_vm._v(_vm._s(_vm.mem.address))]), _vm._v(" जिला "), _c('b', [_vm._v(_vm._s(_vm.mem.district))]), _vm._v(" "), (_vm.mem.state) ? _c('b', [_vm._v("राज्य " + _vm._s(_vm.mem.state.name) + ",")]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(" " + _vm._s(_vm.mem.pin))]), _vm._v(" का मूल निवासी हूँ, \n                            \n                          (1) ऋण करार के अनुसार साप्ताहिक पाक्षिक / क़िस्त मूलधन एवं ब्याज सहित घटते हुए क्रम में क़िस्त लिया जायेगा। (2) ब्याज दर और चार्ज में किसी प्रकार का बदलाव होने पर यह अगले ऋण से लागू होगा (3) द्वितीय पक्ष अपने ऋण के भुगतान अपनी स्वेच्छा से अपनी व्यवसाय के अनुसार आवेदन के दौरान साप्ताहिक पाक्षिक मासिक के रूप में कर सकती है जैसा की सदस्य ने चुना है (4) क़िस्त के भुगतान के देरी होने पर किसी भी अतिरिक्त ब्याज पेनल्टी नहीं लिया जायेगा अपनी इच्छानुसार कभी भी पुनर भुगतान कर सकती है (5)सस्था के कर्मचारियों द्वारा ऋण की वसूली के लिए किसी भी अपमान जनक भाषा का उपयोग एवं मोबाइल कॉल सन्देश का उपयोग नहीं करेंगे । (6) सदस्य को कर्मचारियों द्वारा सुबह 9 बजे से पहले एवं सायं 6 बजे के बाद भारतीय रिजर्व बैंक के नियमानुसार अनुमन्य होगा तथा उपयुक्त ऋण करार में वर्णन किये गए नियम को हमने " + _vm._s(_vm.getCompanyRecord.companyName) + " के कर्मचारी से कंपनी के नियमों एवं शर्तों को स्थानीय भाषा / मातृ भाषा हिंदी में पढ़कर / सुनकर समझ लिया है। (7) कंपनी द्वारा बताई गई सभी शर्तों एवं पक्षों को सहर्ष पूर्वक स्वीकार करता/करती हु और अपने पहचान ही पुष्टि करने हेतु KYC के रूप में आधार कार्ड मतदाता / पहचानपत्र / ड्राविंग लाइसेंस, पैन कार्ड / राशन कार्ड अपनी इच्छा के अनुसार कर्मचारी को सहमति पूर्वक देते हुए उपयुक्त समस्त जानकारी पूर्णतया सत्य दिया गया है सहमति के रूप में हस्ताक्षर करता/करती है। \n                          \n                          ")]) : _vm._e()], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Date: " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(2)]) : _vm._e()])])])]), _vm._v(" "), _vm._m(3)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('strong', [_vm._v("आधार सहमति पत्र / ऋण करार "), _c('br'), _vm._v("(Aadhar Agreement Letter / Loan Agreement)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            CLOSE\n          ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bb28c42e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/components/AdharAgreementLetter.vue
// module id = 881
// module chunks = 0